import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import {
	BrowserRouter as Router,
	Redirect,
	Route,
	Switch,
} from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Home from "../Home/Home";
import Login from "../Login/Login";
import Home from "../Home/Home";
// import SetPassword from "../SetPassword/SetPassword";
// import Signup from "../Signup/Signup";
// import "./../../utils/extension";
import ForgotPassword from "../Login/ForgotPassword";
import ResetPasswordForm from "../Login/ResetPassword";
import AuthenticateExternalSP from "../EServicePartnerServiceRequests/AuthenticateExternalSP";
import EServicePartnerServiceRequest from "../EServicePartnerServiceRequests/EServicePartnerServiceRequest";
import ESPHome from "../EServicePartnerServiceRequests/ESPHome";

// import ResetPassword from "../ResetPassword/ResetPassword";

class App extends Component {
	render() {
		return (
			<div className="min-vh-100">
					<ToastContainer />
					<Router>
						<Switch>
							<Route exact path="/login" component={Login} />
							<Route path="/home" component={Home} />
							<Route
								exact
								path="/"
								render={() => <Redirect to="login" />}
							/>
							<Route
								path="/home"
								render={() => <Home {...this.props} />}
							/>
							<Route
								exact
								path="/forgot_password"
								component={ForgotPassword}
							/>							
							<Route
								exact
								path="/reset_password"
								component={ResetPasswordForm}
							/>
							<Route
								path="/service_partner/login?key=:key"
								component={AuthenticateExternalSP}
							/>
							<Route
								path="/service_partner/login"
								component={AuthenticateExternalSP}
							/>
							
							<Route path="/service_partner" component={ESPHome} />
							<Route
								path="/service_partner"
								render={() => <ESPHome {...this.props} />}
							/>
							{/* <Route exact path="/sign-up" component={Signup} />
            <Route exact path="/set-password" component={SetPassword} />
            <Route exact path="/reset-password" component={ResetPassword} />


            <Route
              exact
              path="/forgot"
              render={() => <div>Forgot Password?</div>}
            /> */}
						</Switch>
					</Router>
			</div>
		);
	}
}

export default App;
